import React from "react";
import { Link, useNavigate } from "react-router-dom";
import "./Button.css";

const Button = ({ text, variant = "primary", link, onClick }) => {
  const navigate = useNavigate();

  const handleClick = (e) => {
    if (onClick) {
      onClick(e);
      return;
    }

    // Handle hash links (like #contact)
    if (link && link.startsWith("#")) {
      e.preventDefault();
      const element = document.querySelector(link);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }

    // Handle home page hash links (like /#contact)
    if (link && link.startsWith("/#")) {
      e.preventDefault();
      navigate("/");
      setTimeout(() => {
        const element = document.querySelector(link.substring(1));
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }, 100);
    }
  };

  // If it's a regular route or hash link
  if (link && (link.startsWith("/") || link.startsWith("#"))) {
    return (
      <Link
        to={link.startsWith("#") ? "/" : link}
        className={`btn btn--${variant}`}
        onClick={handleClick}
      >
        {text}
      </Link>
    );
  }

  // If it's an external link
  return (
    <a
      href={link}
      className={`btn btn--${variant}`}
      onClick={handleClick}
      target={link?.startsWith("http") ? "_blank" : undefined}
      rel={link?.startsWith("http") ? "noopener noreferrer" : undefined}
    >
      {text}
    </a>
  );
};

export default Button;
